const currencyFormatter = Intl.NumberFormat('de', {
  style: 'currency',
  currency: 'EUR',
});

const dateFormatter = Intl.DateTimeFormat('de', {
  dateStyle: 'medium',
});

const numberFormatter = Intl.NumberFormat('de', {
  maximumFractionDigits: 2,
});

export { currencyFormatter, dateFormatter, numberFormatter };
